
























































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import FlightOrder from "@/service/flightService";
import { DurationTime } from "@/utils/utils.ts";
import { Checkbox, CheckboxGroup, Overlay } from "vant";
@Component({
  name: "flightCahngePdt",
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Overlay.name]: Overlay,
  },
  filters: {
    DurationTime,
  },
})
export default class FlightCahngePdt extends Vue {
  //data
  productData = [];
  result: any = [];
  consumerResult: any[] = [];
  isShowRules = false;
  //computed
  get UniqueID(): string {
    return (this as any).$route.query.UniqueID;
  }
  get ServiceCode(): string {
    return (this as any).$route.query.ServiceCode;
  }
  //mounted
  mounted() {
    this.getOrderDetails();
  }
  //methods
  getTripNum(number: number) {
    return number == 0 ? this.$root.$t("order_flight_flightdetail_yi") : this.$root.$t("order_flight_flightdetail_er");
  }
  getOrderDetails() {
    FlightOrder.OrderDetails(this.UniqueID).then(res => {
      if (res.isSucc) {
        this.productData = res.result;
        this.$emit("setProductData", res.result);
      }
    });
  }
  changeProducts(value: any) {
    this.$emit("setResult", value);
  }
  changeConsumers(value: any) {
    this.$emit("setConsumerResult", value);
  }
  formatDate(value: Date, format: string = "HH:mm") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  overlayValue = [];
  showRule(rules: any) {
    if (rules == "") {
      return this.$toast(this.$root.$t("mall_modules_refund_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun"));
    }
    this.overlayValue = rules.split("；");
    this.isShowRules = true;
  }
}
